(function () {
    'use strict';

    angular
        .module('app')
        .controller('AddCampaignCodeController', AddCampaignCodeController);

    AddCampaignCodeController.$inject = ['debug', 'API', 'i18n', '$scope', '$state', '$q', 'helpers',];

    function AddCampaignCodeController(debug, API, i18n, $scope, $state, $q, helpers) {
        var vm = this;
        vm.cancel = $scope.$parent.cancel;
        vm.resolve = $scope.$parent.resolve;
        vm.submit = submit;
        vm.isSubmitting = false;

        vm.newCampaignCode = {
            available_uses: -1,
            active: 1,
        };

        vm.generateCode = generateCode;

        activate();

        function activate() {
            vm.campaign = $scope.placeholders.campaign;
        }

        function submit() {
            if (!vm.isSubmitting) {
                vm.isSubmitting = true;

                vm.newCampaignCode.fk_campaign_id = vm.campaign.id;
                var newCampaignCodeResource = new API.CampaignCode(vm.newCampaignCode);
                var newCampaignCodePromise = newCampaignCodeResource.$save();

                newCampaignCodePromise.then(function(response) {
                    window.toast({ message: i18n.get('NEW_CAMPAIGN_CODE_SAVED'), type: 'success' });
                    $scope.$parent.submit(response);
                }, function() {
                })
                .finally(function() {
                    vm.isSubmitting = false;
                });
            }
        }

        function generateCode() {
            vm.newCampaignCode.code = helpers.generatePassword(15).toLowerCase();
        }

    }
})();